/**
 * 事件参数类型定义
 */
export enum EventParamsTypeConstant {

    MONEY ,//钱币
    MOOD,//心情
    HEALTH,//健康
    STRONGER,//体力
    DEATH,//死亡
    HOUR,//时长
}